import { gql } from '@apollo/client';

export const createSoAdditional = gql`mutation createSoAdditional($input: CreateSoInput!) {
  createSo(input: $input)
}
`